<div class="bg-footer-modal">
  <div class="footer-content">
    <div class="footer-org">
      <div class="footer-logo-shell">
        <img class="footer-logo" src="assets/Image/Logo/color_logo-crezco-mobile.svg"
          alt="Crezco Foundation Logo" />
      </div>

      <div class="verified-paragraph">
        <p class="m-0 small">
          {{ 'CAMPAIGN.Organized' | translate }} {{ org.legalName }}
        </p>

        <p class="m-0 small" *ngIf="org.ein">
          501(c)(3) Public Charity EIN {{ org.ein }}
        </p>

        <p class="m-0 small" *ngIf="org.email">
          {{ org.email }}
        </p>

        <p class="m-0 small" *ngIf="org.extraLine">
          {{ org.extraLine }}
        </p>
      </div>
    </div>

    <div class="verified-footer">
      <img class="verified-footer-icon" src="assets/Image/icons-donate/modal/icon-verified-green.svg"
        alt="Verified Icon" />

      <p class="m-0 small fw-bold">
        {{ 'CAMPAIGN.Verify' | translate }}
      </p>
    </div>
  </div>
</div>
